export default "__VITE_ASSET__739dcd6b__"